import { TabPanel } from "@material-ui/lab";
import React from "react";
import EntryEvent from "../../components/EntryEvent/EntryEvent";
import useBreakpoint from "../../hooks/useBreakpoint";
import { useStore } from "../../hooks/useStore";
import { customTheme } from "../../utils/ThemeConfig";
import MultipleExit from "../../views/MultipleExit/MultipleExit";

const TabEvents = () => {
  const { tabStore } = useStore();
  const { isMobile } = useBreakpoint();

  return (
    <>
      {tabStore.tabs.map((tab) => (
        <TabPanel
          key={tab.index}
          value={tab.index.toString()}
          style={{
            marginTop: isMobile
              ? customTheme.mixins.tabbar.heightMobile
              : customTheme.mixins.tabbar.height,
            padding: 0,
            height: "100%",
          }}
        >
          {tab.isMultipleExit ? (
            <MultipleExit index={tab.index} initialUsers={tab.states} />
          ) : (
            <EntryEvent index={tab.index} initialUser={tab.state} />
          )}
        </TabPanel>
      ))}
    </>
  );
};

export default TabEvents;
